<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path style="fill:#FFFFFF;" d="M12,22.6C6.1,22.6,1.3,17.9,1.3,12S6.1,1.3,12,1.2c2.7,0,5.3,1,7.3,2.8c1,0.9,1.8,2,2.4,3.2
	c0.7,1.4,1,3,1,4.6C22.7,17.9,17.9,22.6,12,22.6z"/>
<g id="_Check_mark_in_circle">
	<path id="Path_357" style="fill:#DC1F26;" d="M12-0.1c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S18.6-0.1,12-0.1z M12,22.6
		C6.1,22.6,1.3,17.9,1.3,12S6.1,1.3,12,1.2c2.7,0,5.3,1,7.3,2.8c1,0.9,1.8,2,2.4,3.2c0.7,1.4,1,3,1,4.6C22.7,17.9,17.9,22.6,12,22.6
		z"/>
</g>
<path id="Path_359" style="fill:#DC1F26;" d="M16.3,7.7c-0.3-0.3-0.7-0.3-0.9,0l0,0L12,11L8.7,7.7c-0.3-0.3-0.7-0.3-1,0
	c-0.3,0.3-0.3,0.7,0,1c0,0,0,0,0,0l3.3,3.3l-3.3,3.3c-0.2,0.3-0.2,0.7,0,1c0.3,0.2,0.7,0.2,0.9,0l3.3-3.3l3.3,3.3
	c0.3,0.2,0.7,0.2,1,0c0.2-0.3,0.2-0.7,0-0.9L13,11.9l3.3-3.3C16.5,8.4,16.5,8,16.3,7.7z"/>
</svg>
